import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M185-106q-32 0-56-23-23-24-23-56v-590q0-33 23-56 24-24 56-24h590q33 0 56 24 24 23 24 56v590q0 32-24 56-23 23-56 23H185Zm0-79h590v-134H634q-26 40-67 62t-87 21q-45 0-86-21t-68-62H185v134Zm295-111q34 0 63-16t45-46q8-11 21-16t27-5h139v-396H185v396h140q13 0 26 5t21 16q16 30 45 46t63 16ZM185-185h590-590Z"/>',
  f: '<path d="M185-106q-32 0-56-23-23-24-23-56v-590q0-33 23-56 24-24 56-24h590q33 0 56 24 24 23 24 56v590q0 32-24 56-23 23-56 23H185Zm295-190q34 0 62-16 29-17 46-46 7-12 20-17 14-4 28-4h139v-396H185v396h140q13 0 27 4 13 5 20 17 17 29 46 46 28 16 62 16Z"/>',
};

export default data;
